import { __assign } from "tslib";
import { SubscriptionData } from '../data/SubscriptionData';
import { getApolloContext } from '../context/ApolloContext';
import { requireReactLazily } from '../react';
export function useSubscription(subscription, options) {
    var React = requireReactLazily();
    var useContext = React.useContext, useState = React.useState, useRef = React.useRef, useEffect = React.useEffect;
    var context = useContext(getApolloContext());
    var updatedOptions = options
        ? __assign(__assign({}, options), { subscription: subscription }) : { subscription: subscription };
    var _a = useState({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = useRef();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) {
            subscriptionDataRef.current = new SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
        }
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    useEffect(function () { return subscriptionData.afterExecute(); });
    useEffect(function () { return subscriptionData.cleanup.bind(subscriptionData); }, []);
    return subscriptionData.execute(result);
}
//# sourceMappingURL=useSubscription.js.map